export const leadStatuses = [
  "Not Contacted",
  "Contacted",
  "Replied",
  "Free Audit Offered",
  "Audit Requested",
  "Audit Sent",
  "Meeting Requested",
  "Meeting Booked",
  "Quote Requested",
  "Quote Sent",
  "Won",
  "Lost",
  "Follow Up Later",
];

export const starterLeads = [];

export const emailScripts = [
  {
    title: "Cold Email Script",
    category: "Email",
    subject: "Digital Growth Opportunity for [INSERT BUSINESS NAME]",
    text: `Hi [INSERT NAME / TEAM],

I hope you are well.

My name is [YOUR NAME] from ProCode ZA. I came across [INSERT BUSINESS NAME] and was impressed by [INSERT SOMETHING SPECIFIC ABOUT THEIR BUSINESS].

At ProCode ZA, we help South African businesses improve their digital presence through affordable websites, digital catalogues, automation tools, AI-supported workflows, SEO improvements and digital marketing support.

After reviewing [INSERT BUSINESS NAME / WEBSITE / SOCIAL MEDIA PAGE], I believe there may be an opportunity to strengthen [INSERT AREA OF OPPORTUNITY]. This could help customers discover your business more easily, understand your offering clearly and engage with your team with less friction.

One of our biggest priorities is making quality digital solutions accessible. Our starter website solutions can begin from as little as R500, depending on the scope and requirements.

I would be happy to send through a free 3-point digital presence audit for [INSERT BUSINESS NAME], outlining what is working well, what could be improved and what a practical low-cost solution could look like.

Would you be open to me sending this through?

Kind regards,
[YOUR NAME]
ProCode ZA`,
  },
  {
    title: "Instagram DM Script",
    category: "Instagram",
    subject: "",
    text: `Hi [Business Name], I hope you are well.

I came across your page and really liked [INSERT SPECIFIC THING - your work, product range, treatments, food, designs, recent posts or brand style].

My name is [YOUR NAME] from ProCode ZA. We help South African businesses improve their online presence through affordable websites, digital catalogues, SEO support, automation tools and digital marketing support.

I noticed there may be an opportunity to strengthen your [website / booking flow / product catalogue / online visibility / customer enquiry process].

We are currently offering free 3-point digital presence audits, where we outline what is working well, what could be improved and what a practical low-cost solution could look like.

Would you be open to me sending one through for [Business Name]?`,
  },
  {
    title: "WhatsApp Message Script",
    category: "WhatsApp",
    subject: "",
    text: `Hi [Name], I hope you are well.

My name is [YOUR NAME] from ProCode ZA. I came across [Business Name] and really liked [INSERT SPECIFIC THING].

We help South African businesses with affordable websites, digital catalogues, SEO support, automation tools and digital marketing support.

I noticed there may be an opportunity to improve your [website / online visibility / customer enquiry process / product presentation].

We are offering free 3-point digital presence audits this week. It simply shows what is working well, what could be improved and what a practical low-cost solution could look like.

Would you be open to me sending one through for [Business Name]?`,
  },
  {
    title: "Follow-Up Script",
    category: "Follow Up",
    subject: "",
    text: `Hi [Name], I hope you are well.

I just wanted to follow up on my previous message regarding a free 3-point digital presence audit for [Business Name].

I believe there may be a few simple ways to improve how customers find, understand and contact your business online.

Would you still be open to me sending through a quick audit?`,
  },
];

export const playbookItems = [
  {
    title: "Lead Sourcing",
    tag: "Sourcing",
    description:
      "Use Google Maps and Instagram first. Look for businesses with no website, weak profile, outdated photos, no booking link or no quote process.",
  },
  {
    title: "Pre-Contact Lead Check",
    tag: "Audit",
    description:
      "Check website, social media, customer journey, products/services, Google visibility and the opportunity ProCode ZA can improve.",
  },
  {
    title: "Personalisation Rules",
    tag: "Outreach",
    description:
      "Every message must mention one real detail about the business. Do not copy-paste the same message without changing context.",
  },
  {
    title: "Handover Rules",
    tag: "Sales",
    description:
      "Hand over when a lead asks for pricing, requests an audit, books a meeting, sends links or shows clear interest.",
  },
];

export const targetIndustries = [
  "Beauty salons",
  "Nail technicians",
  "Hairdressers / barbers",
  "Plumbers / electricians",
  "Cleaning companies",
  "Construction / renovation",
  "Tutors / training centres",
  "Restaurants / caterers",
  "Photographers / videographers",
  "Clothing / product brands",
  "Guesthouses / Airbnbs",
  "Wellness / medical practices",
];

export const objectionReplies = [
  {
    objection: "We already have a website.",
    reply:
      "That is completely understandable. The audit can focus on whether the current website is helping customers take action easily, such as enquiring, requesting quotes, viewing services or finding key information quickly.",
  },
  {
    objection: "How much does it cost?",
    reply:
      "Our starter website solutions can begin from as little as R500, depending on the scope and requirements. The final price depends on pages, design, forms, catalogue features, SEO copy or extra functionality.",
  },
  {
    objection: "We only use Instagram.",
    reply:
      "That makes sense. A website or landing page can work alongside Instagram by giving customers one clear place to view services, prices, contact details and enquiry options.",
  },
  {
    objection: "We do not have budget now.",
    reply:
      "No problem. That is exactly why we offer low-cost starter options and practical recommendations first. The audit can show what small improvements could help now and what can be added later.",
  },
];

export const dailyTargets = [
  { task: "Find new leads", target: "20-30" },
  { task: "Contact new leads", target: "20" },
  { task: "Follow up old leads", target: "10" },
  { task: "Offer free mini audits", target: "5-10" },
  { task: "Update tracker", target: "Daily" },
];